import { Link } from "react-router-dom";

import { PageShell } from "../components/PageShell.js";
import { Seo } from "../components/Seo.js";

export function PrivacyPolicy() {
  return (
    <PageShell>
      <Seo
        title="Privacy Policy · JivaSeva"
        description="How JivaSeva collects, uses, and protects the personal information you share through our website."
        path="/privacy-policy"
      />
      <h1 className="page-heading">Privacy Policy</h1>
      <p className="manifesto">
        <strong>Last Updated:</strong> July 7, 2026
      </p>

      <h2 className="section-heading">Our Commitment to Your Privacy</h2>
      <p className="manifesto">
        JivaSeva respects your privacy and is committed to handling your personal
        information responsibly and transparently. This Privacy Policy explains
        what information we collect through the JivaSeva website, how we use it,
        and the choices available to you.
      </p>
      <p className="manifesto">
        As JivaSeva grows and new services are introduced, this Privacy Policy may
        be updated to reflect those changes.
      </p>

      <h2 className="section-heading">Information We Collect</h2>
      <p className="manifesto">
        At this time, JivaSeva is primarily an informational website. We collect
        only the information that you voluntarily choose to provide.
      </p>
      <p className="manifesto">This may include:</p>
      <ul className="bullet-list">
        <li>Your name.</li>
        <li>Your email address.</li>
        <li>Your phone number (if you choose to provide it).</li>
        <li>
          Any information you include when contacting us through our Contact page
          or by email.
        </li>
      </ul>
      <p className="manifesto">
        Like most websites, our hosting provider may also collect standard
        technical information such as IP addresses, browser type, device
        information, and access logs for security, performance monitoring, and
        troubleshooting.
      </p>

      <h2 className="section-heading">How We Use Your Information</h2>
      <p className="manifesto">We use the information you provide only to:</p>
      <ul className="bullet-list">
        <li>Respond to your questions or inquiries.</li>
        <li>
          Communicate regarding volunteer opportunities or collaboration that you
          have requested.
        </li>
        <li>Improve the website and JivaSeva services.</li>
        <li>Protect the security and integrity of the website.</li>
      </ul>
      <p className="manifesto">
        We do not use your information for unrelated marketing purposes.
      </p>

      <h2 className="section-heading">Information Sharing</h2>
      <p className="manifesto">
        JivaSeva does not sell, rent, or trade your personal information.
      </p>
      <p className="manifesto">
        We may share information only when necessary to operate the website or
        where required by law. This may include trusted service providers who
        assist with website hosting, email delivery, security, or other essential
        services.
      </p>

      <h2 className="section-heading">Data Security</h2>
      <p className="manifesto">
        We take reasonable administrative, technical, and organizational measures
        to help protect the information entrusted to us. However, no method of
        transmitting or storing information electronically can be guaranteed to be
        completely secure.
      </p>

      <h2 className="section-heading">Data Retention</h2>
      <p className="manifesto">
        We retain personal information only for as long as reasonably necessary to
        respond to your inquiry, support JivaSeva's activities, comply with legal
        obligations, or resolve legitimate administrative matters.
      </p>

      <h2 className="section-heading">External Links</h2>
      <p className="manifesto">
        The JivaSeva website may contain links to third-party websites. We are not
        responsible for the privacy practices or content of those websites. We
        encourage you to review their privacy policies before providing personal
        information.
      </p>

      <h2 className="section-heading">Children's Privacy</h2>
      <p className="manifesto">
        The JivaSeva website is intended for a general audience. We do not
        knowingly collect personal information from children under the age of 13.
        If we become aware that such information has been submitted, we will take
        reasonable steps to remove it.
      </p>

      <h2 className="section-heading">Changes to This Policy</h2>
      <p className="manifesto">
        We may update this Privacy Policy from time to time as JivaSeva evolves or
        legal requirements change. The revised version will be posted on this page
        with an updated "Last Updated" date.
      </p>

      <h2 className="section-heading">Contact Us</h2>
      <p className="manifesto">
        If you have any questions about this Privacy Policy or how your information
        is handled, please contact us through the{" "}
        <Link to="/contact" className="inline-link">
          Contact page
        </Link>{" "}
        on this website or by email at{" "}
        <a className="inline-link" href="mailto:support@jivaseva.com">
          support@jivaseva.com
        </a>
        .
      </p>
    </PageShell>
  );
}
